import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, NavDropdown } from 'react-bootstrap';
import { useSelector } from "react-redux";

import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import LoginModal from './LoginModal';
import SignUpModal from './SignUpModal';

import { stylesColors } from '../../utils/publicVariables';

const { blue } = stylesColors;

const classes = {
  button: {
    backgroundColor: blue,
    color: '#ffffff'
  },
}

export default function NavBar() {

  const [modalShowLogin, setModalShowLogin] = React.useState(false);
  const [modalShowSignup, setModalShowSignup] = React.useState(false);

  const auth = useSelector(state => state.auth);
	const { isAuthenticated } = auth;

  return (
    <Navbar expand="md" fixed="top" bg="light" variant="light" className="pt-3 pb-3 shadow">
      <Container>
        <Navbar.Brand as={Link} to="/">YabaPay</Navbar.Brand>
        
        {isAuthenticated?null:(
          <div className="d-block d-md-none">
            <span className="text-primary mr-2" onClick={() =>setModalShowLogin(true)}>LOGIN</span> | {" "}
            <span className="text-primary ml-2" onClick={() => setModalShowSignup(true)}>SIGNUP</span>
          </div>
        )}

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          {isAuthenticated?(
          <Nav.Link eventKey="link-1" as={Link} to="/dashboard">Dashboard</Nav.Link>
          ):null}
          <NavDropdown title="Services" id="basic-nav-dropdown">
            <NavDropdown.Item eventKey="link-1" as={Link} to="/airtime">Buy Airtime</NavDropdown.Item>
            <NavDropdown.Item eventKey="link-1" as={Link} to="/data">Buy Data</NavDropdown.Item>
            <NavDropdown.Item eventKey="link-1" as={Link} to="/power">Pay Power</NavDropdown.Item>
            <NavDropdown.Item eventKey="link-1" as={Link} to="/cable">Pay Cable</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item eventKey="link-1" as={Link} to="/dashboard">More</NavDropdown.Item>
          </NavDropdown>
        </Nav>
          <Nav className="ml-auto mr-5">
            <Nav.Link as={Link} eventKey="link-1" to="/">Home</Nav.Link>
            <Nav.Link as={Link} eventKey="link-1" to="/about-us">About</Nav.Link>
            <Nav.Link as={Link} eventKey="link-1" to="/features">Features</Nav.Link>
            <Nav.Link as={Link} eventKey="link-1" to="/contact">Contact</Nav.Link>
          </Nav>
          {isAuthenticated?(
            <>
              <ul className="navbar-nav navbar-nav-right">
                <li className="nav-item  nav-profile border-0">
                  <Dropdown alignRight>
                    <Dropdown.Toggle className="nav-link count-indicator bg-transparent border-0">
                      <img className="rounded-circle ml-1" style={{width: '2rem'}} src={require("../../assets/images/faces/face8.jpg")} alt="Profile" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="preview-list navbar-dropdown pb-3 pt-3">
                      <Dropdown.Item as={Link} to="/profile" eventKey="link-1" className="dropdown-item preview-item d-flex align-items-center text-small">
                        Manage Account
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/update-password" eventKey="link-1" className="dropdown-item preview-item d-flex align-items-center text-small">
                        Change Password 
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/beneficiaries" eventKey="link-1" className="dropdown-item preview-item d-flex align-items-center text-small">
                        Beneficiaries
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/transactions" eventKey="link-1" className="dropdown-item preview-item d-flex align-items-center text-small">
                        Transactions
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/signout" eventKey="link-1" className="dropdown-item preview-item d-flex align-items-center text-small">
                        Sign Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </>
          ):(
            <>
              <div className="d-none d-sm-block">
                <Button variant="light" onClick={() => setModalShowLogin(true)}>Login</Button>
                <Button variant="ml-4" style={classes.button} className="pl-4 pr-4" onClick={() => setModalShowSignup(true)}>Signup</Button>
              </div>
            </>
          )}
          
        </Navbar.Collapse>
        <LoginModal
          show={modalShowLogin}
          onHide={() => setModalShowLogin(false)}
        />
        <SignUpModal
          show={modalShowSignup}
          onHide={() => setModalShowSignup(false)}
        />
      </Container>
    </Navbar>
  )
}
